import config from '../config'
import APIService from '../APIService'

export default {
    fetchCompanyById: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/teamadmin/${id}`,
            method: 'GET',
        })
    },
    getAll: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/teamadmin/all/${id}`,
            method: 'GET',
        })
    },
    create: (data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/teamadmin`,
            method: 'POST',
            data
        })
    },
    update: (id, data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/teamadmin/${id}`,
            method: 'PATCH',
            data
        })
    },
    delete: (id, data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/teamadmin/${id}`,
            method: 'DELETE',
            data
        })
    }
}